// 2026-10-25 にイベント編集ページが真っ白になった障害の再発防止。
// application パックは <head> で csrf_meta_tags より前に評価されるので、このモジュールは
// 読み込み時に <meta name="csrf-token"> が無くても壊れず、要求を送る瞬間のトークンを付けなければならない。
const loadInstance = () => {
  let instance;
  jest.isolateModules(() => {
    instance = require('./axios').default;
  });
  return instance;
};

// ネットワークに出さず、送ろうとした config をそのまま返す
const stubAdapter = (instance) => {
  instance.defaults.adapter = (config) =>
    Promise.resolve({ data: {}, status: 200, statusText: 'OK', headers: {}, config });
};

const addCsrfMeta = (content) => {
  const meta = document.createElement('meta');
  meta.name = 'csrf-token';
  meta.content = content;
  document.head.appendChild(meta);
};

describe('components/axios（CSRF トークンを読むタイミング）', () => {
  afterEach(() => {
    document.head.innerHTML = '';
  });

  it('読み込み時に csrf-token の meta が無くても例外にならない（パック全体を止めない）', () => {
    expect(document.getElementsByName('csrf-token')).toHaveLength(0);
    expect(() => loadInstance()).not.toThrow();
  });

  it('読み込み後に足された meta のトークンを、要求を送る瞬間に X-CSRF-Token へ付ける', async () => {
    const instance = loadInstance(); // meta が無い状態で読み込む
    stubAdapter(instance);
    addCsrfMeta('token-after-load');

    const res = await instance.get('/api/dummy');
    expect(res.config.headers['X-CSRF-Token']).toBe('token-after-load');
  });

  it('meta が無いまま送るときは空文字（undefined のヘッダにしない）', async () => {
    const instance = loadInstance();
    stubAdapter(instance);

    const res = await instance.post('/api/dummy', {});
    expect(res.config.headers['X-CSRF-Token']).toBe('');
  });

  it('Accept / Content-Type は JSON のまま', async () => {
    addCsrfMeta('t');
    const instance = loadInstance();
    stubAdapter(instance);

    const res = await instance.get('/api/dummy');
    expect(res.config.headers.Accept).toBe('application/json');
    expect(res.config.headers['Content-Type']).toBe('application/json');
    expect(res.config.responseType).toBe('json');
  });
});
